export const initialState = {
    reportsList:[],
    reportsLoading: false,
    menuLabels: []
  };
  